import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
// Phase 5 Animation System CSS imports
import '@/components/animations/skeleton-animations.css'
import '@/components/animations/mvpblocks-enhancements.css'

import App from './App.tsx';

// Phase : Auth
import { ClerkProvider } from '@clerk/clerk-react';


// import getBaseUrl from './lib/config.ts'
// const BASE_URL = getBaseUrl(); //not essential, but good practice

const PUBLISHABLE_TESTKEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY_TEST; //for test use only
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ClerkProvider publishableKey={PUBLISHABLE_TESTKEY}>
      <App />
    </ClerkProvider>
  </StrictMode>,
)


const PUBLISHABLE_LIVEKEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY_LIVE; //for production use only
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ClerkProvider publishableKey={PUBLISHABLE_LIVEKEY}>
      <App/>
    </ClerkProvider>
  </StrictMode>
)
